import {
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
  EPG_EVENTS_BY_GENRE_PATH,
  FAVORITE_USER_PATH_SERVICES,
  MULTI_PBI_PATH_SERVICES,
  PURCHASE_ACTIVE_PATH_SERVICES,
  SEARCH_LINEAL_PREDICTIVE,
  USER_CHANNELS_SEEN,
  USER_CHANNELS_SEEN_PATH,
  USER_RECOMMENDATIONS,
  USER_SEEN_PATH_SERVICES,
} from 'api/services/content/paths';
import { NAV_EXPERIENCE_PATH_SERVICE } from 'api/services/nav/paths';
import {
  USER_FAVORITE_ADD_PATH,
  USER_FAVORITE_DEL_PATH,
} from 'api/services/user/paths';

export const transformUserSeenResponse = (response, url) => {
  if (url?.includes(USER_SEEN_PATH_SERVICES))
    return (response.data = { response: response.data.data });
};
export const transformLinealPredictiveResponse = (response, url) => {
  if (url?.includes(SEARCH_LINEAL_PREDICTIVE))
    return (response.data = { response: response.data.data });
};

export const transformCmsLevelResponse = (response, url) => {
  const {modules, ...resData} = response?.data?.data || {};
  if (url?.includes(CMS_LEVEL_PATH_SERVICES))
    return (response.data = {
      response: { modules: { module: response.data.data.modules }, metadata: resData },
    });
  if (url?.includes(CMS_LEVEL_USER_PATH_SERVICES))
    return (response.data = {
      response: { modules: { module: response.data.data.modules } },
    });
};

export const transformUserFavoriteResponse = (response, url) => {
  if (url?.includes(FAVORITE_USER_PATH_SERVICES))
    return (response.data = { response: response.data.data });
};

export const transformUserChannelsSeenResponse = (response, url) => {
  if (url?.includes(USER_CHANNELS_SEEN_PATH))
    return (response.data = { response: response.data.data });
};
export const transformResponseEPGEventsByGenre = (response, url) => {
  if (url?.includes(EPG_EVENTS_BY_GENRE_PATH))
    return (response.data = { response: response.data.data });
};

export const transformUserFavoriteAddResponse = (response, url) => {
  if (url?.includes(USER_FAVORITE_ADD_PATH))
    return (response.data = {
      ...response.data.data,
      status: response.data.data.add ? '0' : '1',
    });
};

export const transformUserFavoriteDeleteResponse = (response, url) => {
  if (url?.includes(USER_FAVORITE_DEL_PATH)) {
    return (response.data = {
      ...response.data.response,
      status: response.data.response.delete ? '0' : '1',
    });
  }
};
export const transformPurchaseactiveresponse = (response, url) => {
  if (url?.includes(PURCHASE_ACTIVE_PATH_SERVICES))
    return (response.data = { response: response.data.data });
};

export const transformNavExperienceResponse = (response, url) => {
  if (url?.includes(NAV_EXPERIENCE_PATH_SERVICE))
    return (response.response = { ...response.data.data });
};

export const transformMultiPbiResponse = (response, url) => {
  if (url?.includes(MULTI_PBI_PATH_SERVICES)) {
    return (response.data = { data: response.data.response });
  }
};

export const transformUserRecommendations = (response, url) => {
  if(url?.includes(USER_RECOMMENDATIONS)){
    return (response.data = { response : response.data.data});
  }
}
